// extracted by mini-css-extract-plugin
module.exports = {"label":"K_b6","text":"K_cC"};